import { Component, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from '@core/auth';
import { SessionValidityService } from '@core/auth/session-validator.service';
import { CountdownClock, CountdownClockModal } from '@shared/logout-warning-modal/countdown-clock';

@Component({
  selector: 'mojo-logout-warning-modal',
  templateUrl: './logout-warning-modal.component.html',
  styleUrls: ['./logout-warning-modal.component.scss'],
})
export class LogoutWarningModalComponent implements OnDestroy {
  title: string;
  subtitle: string;
  countdownClock: CountdownClock;
  resumable: boolean;
  interval;

  constructor(
    private dialogRef: MatDialogRef<LogoutWarningModalComponent>,
    @Inject(MAT_DIALOG_DATA) private props: CountdownClockModal,
    private authService: AuthService,
    private sv: SessionValidityService,
  ) {
    this.resumable = props.resumable;
    this.title = props.title;
    this.subtitle = props.subtitle;
    this.countdownClock = {
      from: props.from,
      counter: props.from,
      current: 0,
    };
    this.interval = setInterval(() => {
      this.countdownClock.current++;
      this.countdownClock.counter = this.countdownClock.from - this.countdownClock.current;
      if (this.resumable && !this.sv.shouldShowIdleWarning) {
        this.dialogRef.close();
      }
      if (!this.resumable) {
        localStorage.setItem('countdown_clock', JSON.stringify(this.countdownClock));
      }
      if (this.countdownClock.current >= this.countdownClock.from) {
        clearInterval(this.interval);
        this.props.logoutCallback();
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    if (!this.resumable) {
      this.dialogRef.close(this.countdownClock);
    }
    clearInterval(this.interval);
  }

  close(): void {
    this.props.buttonCallback();
    this.dialogRef.close();
  }
}
